import React from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import { useAppSelector } from '../../../../hooks/hooks';
import { selectListItems } from '../../../../redux/library/selector';
import GlobalDbnBluePrintRegistriesBasicInfoComponent from './global-blue-print-registries-basic-Info';
import GlobalDbnBluePrintRegistriesServiceCategoryGroups from './global-blue-print-registriey-service-category-groups';
import GlobalDbnBluePrintRegistriesLegTemplate from './global-blue-print-registries-leg-template';



export const GlobalDbnBluePrintRegistriesComponent =  ({PlanType,handleDelete,addLegTemplate,RoutingModels,handleInnerChange,subselectedCategory,FulfillmentExtent,LifeCycleStatus,handleInnerFormChange,selectedCategory, 
 back,handleFormSubmit,GlobalDbnServiceCategory,deleteLegTemplate,legTemplates,LegType,MovementPattern,
HaulClass,handleInnerLegTemplateChange,handleDeleteGroup,handleAddGroup,selectedGroups,handleSelectedGroups}: any) => {
    const libraryData = useAppSelector(selectListItems)

  const tabItems=[
    {
        id:1,
        title:'New Blue Print Registry',
        component:<GlobalDbnBluePrintRegistriesBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        handleInnerChange={handleInnerChange}
        subselectedCategor={subselectedCategory}
        selectedCategory={selectedCategory}
        LifeCycleStatus={LifeCycleStatus}
         RoutingModels={RoutingModels}
        PlanType={PlanType}
        />,
    isVisible:true,
    },
   {
     id: 2,
     title: "Leg Template",
     component: (
       <GlobalDbnBluePrintRegistriesLegTemplate
         subselectedCategor={subselectedCategory}
         selectedCategory={selectedCategory}
         addLegTemplate={addLegTemplate}
         legTemplates={legTemplates}
         MovementPattern={MovementPattern}
         LegType={LegType}
         HaulClass={HaulClass}
         deleteLegTemplate={deleteLegTemplate}
         handleInnerLegTemplateChange={handleInnerLegTemplateChange}
       />
     ),
     isVisible: true,
   },
   {
     id: 3,
     title: "Service Category Groups",
     component: (
       <GlobalDbnBluePrintRegistriesServiceCategoryGroups
         handleInnerFormChange={handleInnerFormChange}
         selectedGroups={selectedGroups}
         selectedCategory={selectedCategory}
         handleDelete={handleDelete}
         handleAddGroup={handleAddGroup}
         handleSelectedGroups={handleSelectedGroups}
         GlobalDbnServiceCategory={GlobalDbnServiceCategory}
         handleDeleteGroup={handleDeleteGroup}
       />
     ),
     isVisible: true,
   }, 
   ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default GlobalDbnBluePrintRegistriesComponent;
